import axios from "axios";

export const fetchVehicle = async (vehicleIdentificationNumber, bearer) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_REST_API_VEHICLE,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
        params: {
          VIN: vehicleIdentificationNumber,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const postRemoteAction = async (
  vehicleIdentificationNumber,
  actions,
  bearer,
) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL_REST_API_VEHICLE}/${vehicleIdentificationNumber}/remote-actions`,
      actions,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchCapture = async (vehicleIdentificationNumber, row, seat, bearer) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_REST_API_VEHICLE + `/${vehicleIdentificationNumber}/images?row=${row}&seat=${seat}`,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};